import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AutoLogoutWarning.css';

function AutoLogoutWarning({ show, onExtend, onLogout }) {
  const [timeLeft, setTimeLeft] = useState(120); // 2 minutes in seconds

  useEffect(() => {
    if (show) {
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
      // Reset countdown when modal shows
      setTimeLeft(120);
    } else {
      // Restore body scroll when modal is closed
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  useEffect(() => {
    if (!show) {
      setTimeLeft(120);
      return;
    }

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [show]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="auto-logout-backdrop"
          onClick={onExtend}
        >
          {/* Warning Modal */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: -20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: -20 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            className="auto-logout-warning"
            onClick={e => e.stopPropagation()}
          >
            <div className="warning-icon">⏰</div>
            <h2>Session Expiring Soon</h2>
            <p>You will be logged out due to inactivity in:</p>
            <div className="countdown">{formatTime(timeLeft)}</div>
            <p className="warning-text">
              Click "Stay Logged In" to continue your session.
            </p>
            <div className="warning-actions">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="extend-btn"
                onClick={onExtend}
              >
                Stay Logged In
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="logout-btn"
                onClick={onLogout}
              >
                Logout Now
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default AutoLogoutWarning;
